import React from "react";
import { TextField } from "@mui/material";
import FieldLabel from "./FieldLabel";

const SubscriptionNameField = ({ value, onChange, placeholder }) => (
	<div>
		<FieldLabel required>Name</FieldLabel>
		<TextField
			name="subscriptionName"
			variant="outlined"
			fullWidth
			value={value || ""}
			placeholder={placeholder || "e.g. Weekly defects digest"}
			onChange={(e) => onChange(e.target.value)}
		/>
	</div>
);

export default SubscriptionNameField;
